import React from "react";

function Results() {
  return (
    <section id="aftercontest" className="organization-section">
      <h2>Resultados</h2>
        <div className="organization-column">
          <div className="map-container">
            <img
              src="imgs/miup24_finalclassification.png"
              alt="Resultados"
              width="100%"
            ></img>
          </div>
        </div>
    </section>
  );
}

export default Results;
